import * as React from 'react'
import styled from 'styled-components'
import { fontSizes, screenSizes } from '@src/styles/theme'
import { colors } from '@src/styles/theme'

const FullPageContainer = styled.div<any>`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 40px 24px;
  min-height: 60vh;

  @media (max-width: ${screenSizes.M}px) {
    padding: 20px 12px;
  }
`

const PageTitle = styled.h1<any>`
  font-family: 'NunitoSansSemiBold';
  font-size: ${fontSizes.L};
  color: ${(props: any) => props.theme.title};
  margin: 0 0 16px 0;
`

const PageDescription = styled.p<any>`
  font-size: ${fontSizes.XS};
  color: ${(props: any) => props.theme.listDesc || '#9CA6AD'};
  max-width: 600px;
  text-align: center;
  line-height: 1.6;
`

const FeatureList = styled.div<any>`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 16px;
  max-width: 800px;
  width: 100%;
  margin-top: 32px;
`

const FeatureCard = styled.div<any>`
  background: ${(props: any) => props.theme.panelBack || 'rgba(255,255,255,0.05)'};
  border-radius: ${(props: any) => props.theme.radius || '4px'};
  padding: 20px;
  border: 1px solid rgba(206, 218, 225, 0.15);
`

const FeatureTitle = styled.h3<any>`
  font-family: 'NunitoSansSemiBold';
  font-size: ${fontSizes.XXS};
  color: ${(props: any) => props.theme.title || '#FFF'};
  margin: 0 0 8px 0;
`

const FeatureDesc = styled.p<any>`
  font-size: 13px;
  color: ${(props: any) => props.theme.listDesc || '#9CA6AD'};
  margin: 0;
  line-height: 1.5;
`

export const AiChatPage: React.FC<any> = () => {
  return (
    <FullPageContainer>
      <PageTitle>Equanaut AI</PageTitle>
      <PageDescription>
        Your AI-powered assistant for managing organizations, cap tables, and equity.
        Use the Equanaut panel on the right side of any page for quick access, or explore the features below.
      </PageDescription>
      <FeatureList>
        <FeatureCard>
          <FeatureTitle>Chat Assistant</FeatureTitle>
          <FeatureDesc>
            Ask questions about your organizations, cap tables, and equity management.
            Click the AI button in the header to start a conversation.
          </FeatureDesc>
        </FeatureCard>
        <FeatureCard>
          <FeatureTitle>Tool Execution</FeatureTitle>
          <FeatureDesc>
            Equanaut can execute actions on your behalf — creating organizations,
            managing members, and more.
          </FeatureDesc>
        </FeatureCard>
        <FeatureCard>
          <FeatureTitle>Conversation History</FeatureTitle>
          <FeatureDesc>
            Your conversations are saved locally. Access previous chats and
            continue where you left off.
          </FeatureDesc>
        </FeatureCard>
      </FeatureList>
    </FullPageContainer>
  )
}

export default AiChatPage
